import { TCollectionIcons } from '@/types';

const publisherIcons: TCollectionIcons = {
  banner: `
  <svg
    width="136"
    height="109"
    viewBox="0 0 136 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H128C132.142 0.5 135.5 3.85786 135.5 8V105C135.5 106.933 133.933 108.5 132 108.5H4C2.06701 108.5 0.5 106.933 0.5 105V8Z"
      fill="white"
      stroke="#EDF1F5"
    />
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H128C132.418 0 136 3.58172 136 8V22H0V8Z"
      fill="#EDF1F5"
    />
    <path
      d="M9 34C9 31.7909 10.7909 30 13 30H61C63.2091 30 65 31.7909 65 34V66C65 68.2091 63.2091 70 61 70H13C10.7909 70 9 68.2091 9 66V34Z"
      fill="#EDF1F5"
    />
    <path
      d="M9 80C9 77.7909 10.7909 76 13 76H61C63.2091 76 65 77.7909 65 80C65 82.2091 63.2091 84 61 84H13C10.7909 84 9 82.2091 9 80Z"
      fill="#EDF1F5"
    />
    <path
      d="M9 93C9 90.7909 10.7909 89 13 89H61C63.2091 89 65 90.7909 65 93C65 95.2091 63.2091 97 61 97H13C10.7909 97 9 95.2091 9 93Z"
      fill="#EDF1F5"
    />
    <path
      d="M70 35C70 32.7909 71.7909 31 74 31H122C124.209 31 126 32.7909 126 35V66C126 68.2091 124.209 70 122 70H74C71.7909 70 70 68.2091 70 66V35Z"
      fill="#52A1FF"
    />
  </svg>`,
  native: `
  <svg
    width="136"
    height="109"
    viewBox="0 0 136 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H128C132.142 0.5 135.5 3.85786 135.5 8V105C135.5 106.933 133.933 108.5 132 108.5H4C2.06701 108.5 0.5 106.933 0.5 105V8Z"
      fill="white"
      stroke="#EDF1F5"
    />
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H128C132.418 0 136 3.58172 136 8V22H0V8Z"
      fill="#EDF1F5"
    />
    <path
      d="M8 32C8 29.7909 9.79086 28 12 28H60C62.2091 28 64 29.7909 64 32V57C64 59.2091 62.2091 61 60 61H12C9.79086 61 8 59.2091 8 57V32Z"
      fill="#EDF1F5"
    />
    <path
      d="M70 30.5C70 29.1193 71.1193 28 72.5 28H123.5C124.881 28 126 29.1193 126 30.5C126 31.8807 124.881 33 123.5 33H72.5C71.1193 33 70 31.8807 70 30.5Z"
      fill="#EDF1F5"
    />
    <path
      d="M70 40.5C70 39.1193 71.1193 38 72.5 38H123.5C124.881 38 126 39.1193 126 40.5C126 41.8807 124.881 43 123.5 43H72.5C71.1193 43 70 41.8807 70 40.5Z"
      fill="#EDF1F5"
    />
    <path
      d="M70 50.5C70 49.1193 71.1193 48 72.5 48H103.5C104.881 48 106 49.1193 106 50.5C106 51.8807 104.881 53 103.5 53H72.5C71.1193 53 70 51.8807 70 50.5Z"
      fill="#EDF1F5"
    />
    <path
      d="M10 73C10 70.7909 11.7909 69 14 69H32C34.2091 69 36 70.7909 36 73V73.3333C36 75.5425 34.2091 77.3333 32 77.3333H14C11.7909 77.3333 10 75.5425 10 73.3333V73Z"
      fill="#52A1FF"
    />
    <path
      d="M10 85.3335C10 83.1244 11.7909 81.3335 14 81.3335H32C34.2091 81.3335 36 83.1244 36 85.3335V85.6668C36 87.876 34.2091 89.6668 32 89.6668H14C11.7909 89.6668 10 87.876 10 85.6668V85.3335Z"
      fill="#52A1FF"
    />
    <path
      d="M10 97.6665C10 95.4574 11.7909 93.6665 14 93.6665H32C34.2091 93.6665 36 95.4574 36 97.6665V97.9998C36 100.209 34.2091 102 32 102H14C11.7909 102 10 100.209 10 97.9998V97.6665Z"
      fill="#52A1FF"
    />
    <path
      d="M40 73C40 70.7909 41.7909 69 44 69H62C64.2091 69 66 70.7909 66 73V73.3333C66 75.5425 64.2091 77.3333 62 77.3333H44C41.7909 77.3333 40 75.5425 40 73.3333V73Z"
      fill="#52A1FF"
    />
    <path
      d="M40 85.3335C40 83.1244 41.7909 81.3335 44 81.3335H62C64.2091 81.3335 66 83.1244 66 85.3335V85.6668C66 87.876 64.2091 89.6668 62 89.6668H44C41.7909 89.6668 40 87.876 40 85.6668V85.3335Z"
      fill="#52A1FF"
    />
    <path
      d="M40 97.6665C40 95.4574 41.7909 93.6665 44 93.6665H62C64.2091 93.6665 66 95.4574 66 97.6665V97.9998C66 100.209 64.2091 102 62 102H44C41.7909 102 40 100.209 40 97.9998V97.6665Z"
      fill="#52A1FF"
    />
    <path
      d="M70 73C70 70.7909 71.7909 69 74 69H92C94.2091 69 96 70.7909 96 73V73.3333C96 75.5425 94.2091 77.3333 92 77.3333H74C71.7909 77.3333 70 75.5425 70 73.3333V73Z"
      fill="#52A1FF"
    />
    <path
      d="M70 85.3335C70 83.1244 71.7909 81.3335 74 81.3335H92C94.2091 81.3335 96 83.1244 96 85.3335V85.6668C96 87.876 94.2091 89.6668 92 89.6668H74C71.7909 89.6668 70 87.876 70 85.6668V85.3335Z"
      fill="#52A1FF"
    />
    <path
      d="M70 97.6665C70 95.4574 71.7909 93.6665 74 93.6665H92C94.2091 93.6665 96 95.4574 96 97.6665V97.9998C96 100.209 94.2091 102 92 102H74C71.7909 102 70 100.209 70 97.9998V97.6665Z"
      fill="#52A1FF"
    />
    <path
      d="M100 73C100 70.7909 101.791 69 104 69H122C124.209 69 126 70.7909 126 73V73.3333C126 75.5425 124.209 77.3333 122 77.3333H104C101.791 77.3333 100 75.5425 100 73.3333V73Z"
      fill="#52A1FF"
    />
    <path
      d="M100 85.3335C100 83.1244 101.791 81.3335 104 81.3335H122C124.209 81.3335 126 83.1244 126 85.3335V85.6668C126 87.876 124.209 89.6668 122 89.6668H104C101.791 89.6668 100 87.876 100 85.6668V85.3335Z"
      fill="#52A1FF"
    />
    <path
      d="M100 97.6665C100 95.4574 101.791 93.6665 104 93.6665H122C124.209 93.6665 126 95.4574 126 97.6665V97.9998C126 100.209 124.209 102 122 102H104C101.791 102 100 100.209 100 97.9998V97.6665Z"
      fill="#52A1FF"
    />
  </svg>`,
  push: `
  <svg
    width="136"
    height="109"
    viewBox="0 0 136 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H128C132.142 0.5 135.5 3.85786 135.5 8V105C135.5 106.933 133.933 108.5 132 108.5H4C2.06701 108.5 0.5 106.933 0.5 105V8Z"
      fill="white"
      stroke="#EDF1F5"
    />
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H128C132.418 0 136 3.58172 136 8V22H0V8Z"
      fill="#EDF1F5"
    />
    <path
      d="M9 34C9 31.7909 10.7909 30 13 30H61C63.2091 30 65 31.7909 65 34V66C65 68.2091 63.2091 70 61 70H13C10.7909 70 9 68.2091 9 66V34Z"
      fill="#EDF1F5"
    />
    <path
      d="M71 53C71 50.7909 72.7909 49 75 49H123C125.209 49 127 50.7909 127 53C127 55.2091 125.209 57 123 57H75C72.7909 57 71 55.2091 71 53Z"
      fill="#EDF1F5"
    />
    <path
      d="M71 66C71 63.7909 72.7909 62 75 62H123C125.209 62 127 63.7909 127 66C127 68.2091 125.209 70 123 70H75C72.7909 70 71 68.2091 71 66Z"
      fill="#EDF1F5"
    />
    <path
      d="M9 80C9 77.7909 10.7909 76 13 76H121C123.209 76 125 77.7909 125 80C125 82.2091 123.209 84 121 84H13C10.7909 84 9 82.2091 9 80Z"
      fill="#EDF1F5"
    />
    <path
      d="M9 93C9 90.7909 10.7909 89 13 89H85C87.2091 89 89 90.7909 89 93C89 95.2091 87.2091 97 85 97H13C10.7909 97 9 95.2091 9 93Z"
      fill="#EDF1F5"
    />
    <path
      d="M132 38C132 40.2091 130.209 42 128 42H91C88.7909 42 87 40.2091 87 38V30C87 27.7909 88.7909 26 91 26H128C130.209 26 132 27.7909 132 30V38Z"
      fill="#52A1FF"
    />
  </svg>`,
  editContent: `
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1H2C1.44772 1 1 1.44772 1 2V6C1 6.55228 1.44772 7 2 7H6C6.55228 7 7 6.55228 7 6V2C7 1.44772 6.55228 1 6 1Z"
      stroke="#2B7AF0"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 13H14C13.4477 13 13 13.4477 13 14V18C13 18.5523 13.4477 19 14 19H18C18.5523 19 19 18.5523 19 18V14C19 13.4477 18.5523 13 18 13Z"
      stroke="#2B7AF0"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 9V6C19 5.46957 18.7893 4.96086 18.4142 4.58579C18.0391 4.21071 17.5304 4 17 4H11M11 4L14 7M11 4L14 1"
      stroke="#2B7AF0"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 11V14C1 14.5304 1.21071 15.0391 1.58579 15.4142C1.96086 15.7893 2.46957 16 3 16H9M9 16L6 13M9 16L6 19"
      stroke="#2B7AF0"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>`,
  addContent: `
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8211 6.82105C15.4947 6.82105 16 7.32632 16 8C16 8.33684 15.8737 8.63158 15.6632 8.8421C15.4526 9.05263 15.1579 9.17895 14.8211 9.17895L9.17895 9.17895L9.17895 14.8211C9.17895 15.1579 9.05263 15.4526 8.84211 15.6632C8.63158 15.8737 8.33684 16 8 16C7.32632 16 6.82105 15.4947 6.82105 14.8211L6.82105 9.17895H1.17895C0.505263 9.17895 0 8.67368 0 8C0 7.32632 0.505263 6.82105 1.17895 6.82105H6.82105L6.82105 1.17895C6.82105 0.505264 7.32632 0 8 0C8.67368 0 9.17895 0.505263 9.17895 1.17895L9.17895 6.82105L14.8211 6.82105Z"
      fill="#2B7AF0"
    />
  </svg>`,
};

export default publisherIcons;
